module.exports = __webpack_public_path__ + "static/img/management-01.20581da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/management-01.png
// module id = Sz2z
// module chunks = 0